/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminTransactionDto { 
    id?: number;
    created?: string;
    finishedAt?: string;
    type?: string;
    status?: string;
    points?: number;
    errorMessage?: string;
    companyId?: number;
    companyName?: string;
    userEmail?: string;
    userName?: string;
    invoiceNo?: string;
    jir?: string;
    hasImage?: boolean;
}

